import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Spin from 'antd/lib/spin';
import NmcInfo from '../../blocks/PageInfo/NmcInfo';
import api from '../../../helpers/api';

import style from './index.module.scss';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

const NmcContent = () => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [url, setUrl] = useState<string | null>(null);

  const path = useHistory().location.pathname;

  const onReport = async () => {
    const pathParams = path.split('/nmc/')[1]?.replace(/-/g, '_')?.toUpperCase();

    const arrRepodrtTypes = [
      api.API_OKPD2_REPORT_TYPE,
      api.API_NMCK_REPORT_TYPE,
      api.API_SKP_REPORT_TYPE,
      api.API_PURCHASES_DOCS_REPORT_TYPE,
    ];

    if (!arrRepodrtTypes.includes(pathParams)) {
      return;
    }

    await api.sendReport(pathParams, {
      ...getReferrerFrom(),
    });
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const pathParams = path.split('/nmc/')[1];
      if (path === '/nmc') {
        const res = await api.getUrlIframe('okpd2');
        setUrl(res.url);
        setLoading(false);
      } else {
        const res = await api.getUrlIframe(pathParams);
        setUrl(res.url);
        setLoading(false);
      }
    })();
  }, [path]);
  return (
    <>
      <div className={style.container}>
        <NmcInfo />
      </div>
      <div className={style.frame}>
        {!isLoading && url ? (
          <iframe onLoad={onReport} width="100%" height="100%" src={url} title="Selton" />
        ) : (
          <div className={style.spin}>
            <Spin />
          </div>
        )}
      </div>
    </>
  );
};

export default NmcContent;
